/**
 * Sorts dates based on specified order
 * @param {string|Date} dateA - First date to compare
 * @param {string|Date} dateB - Second date to compare
 * @param {string} sortOrder - 'asc' for oldest to newest, 'desc' for newest to oldest
 * @returns {number} - Comparison result (-1, 0, or 1)
 * @description Sorts dates by converting them to milliseconds
 */
export default function dateSort(dateA, dateB, sortOrder = 'asc') {
  // Handle null or undefined values
  if (!dateA && !dateB) return 0;
  if (!dateA) return sortOrder === 'asc' ? 1 : -1;
  if (!dateB) return sortOrder === 'asc' ? -1 : 1;

  // Convert to milliseconds
  const date1 = new Date(dateA).getTime();
  const date2 = new Date(dateB).getTime();

  // Handle invalid dates
  if (isNaN(date1) && isNaN(date2)) return 0;
  if (isNaN(date1)) return sortOrder === 'asc' ? 1 : -1;
  if (isNaN(date2)) return sortOrder === 'asc' ? -1 : 1;

  // Compare dates based on sort order
  if (sortOrder === 'asc') {
    return date1 > date2 ? 1 : date1 < date2 ? -1 : 0;
  } else {
    return date1 < date2 ? 1 : date1 > date2 ? -1 : 0;
  }
}
